<template>
  <div class="main-wrapper login-body">
    <div class="login-wrapper">
      <div class="container">
        <img class="img-fluid logo-dark mb-2" src="@/assets/img/testpal-full.png" alt="Logo" />
        <div class="loginbox">
          <div class="login-right">
            <div class="login-right-wrap">
              <h1>Reset Password</h1>
              <p class="account-subtitle">Enter your new password</p>

              <div v-if="success" class="text-center">
                <div class="alert alert-success">
                  Your password has been reset successfully!
                </div>
                <router-link to="/" class="btn btn-primary">
                  Back to Login
                </router-link>
              </div>

              <form v-else @submit.prevent="handleSubmit">
                <div class="input-block mb-3">
                  <label class="form-label">New Password <span class="text-danger">*</span></label>
                  <div class="pass-group">
                    <input
                      v-model="form.password"
                      :type="showPassword ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Enter new password"
                      required
                      minlength="8"
                    />
                    <span class="toggle-password" @click="showPassword = !showPassword">
                      <vue-feather :type="showPassword ? 'eye-off' : 'eye'" />
                    </span>
                  </div>
                </div>

                <div class="input-block mb-3">
                  <label class="form-label">Confirm Password <span class="text-danger">*</span></label>
                  <div class="pass-group">
                    <input
                      v-model="form.passwordConfirmation"
                      :type="showConfirmPassword ? 'text' : 'password'"
                      class="form-control"
                      placeholder="Confirm new password"
                      required
                    />
                    <span class="toggle-password" @click="showConfirmPassword = !showConfirmPassword">
                      <vue-feather :type="showConfirmPassword ? 'eye-off' : 'eye'" />
                    </span>
                  </div>
                </div>

                <div v-if="error" class="alert alert-danger mb-3">
                  {{ error }}
                </div>

                <div class="input-block mb-0">
                  <button type="submit" class="btn btn-primary w-100" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'ResetPassword',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const authStore = useAuthStore()

    const form = ref({ password: '', passwordConfirmation: '' })
    const showPassword = ref(false)
    const showConfirmPassword = ref(false)
    const loading = ref(false)
    const error = ref('')
    const success = ref(false)
    const token = ref('')

    onMounted(() => {
      token.value = route.query.token
      if (!token.value) {
        router.push({ name: 'login' })
      }
    })

    const handleSubmit = async () => {
      if (form.value.password !== form.value.passwordConfirmation) {
        error.value = 'Passwords do not match'
        return
      }

      loading.value = true
      error.value = ''

      try {
        await authStore.resetPassword(
          token.value,
          form.value.password,
          form.value.passwordConfirmation
        )
        success.value = true
      } catch (err) {
        error.value = err
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      showPassword,
      showConfirmPassword,
      loading,
      error,
      success,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.login-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f8f9fa;
}

.login-wrapper {
  width: 100%;
  max-width: 500px;
  padding: 20px;
}

.loginbox {
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  padding: 40px;
}

.logo-dark {
  max-width: 180px;
  display: block;
  margin: 0 auto 20px;
}

h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
}

.account-subtitle {
  color: #6c757d;
  text-align: center;
  margin-bottom: 30px;
}

.pass-group {
  position: relative;
}

.toggle-password {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
}
</style>
